<div class="container">
  <div class="header" [formGroup]="viewForm">
    <app-event-filters
      [organizations]="organizations"
      [events]="events"
      [regions]="regions"
      (filtersChanged)="onFiltersChanged($event)"
    ></app-event-filters>

    <app-export-reports
      [events]="filteredEvents"
      [filters]="currentFilters"
      [showPendingEvents]="showPendingEvents"
      [showCompletedEvents]="showCompletedEvents"
    ></app-export-reports>

    <app-button-group
      [options]="viewOptions"
      formControlName="view"
    ></app-button-group>
  </div>
  <div class="content">
    <div
      class="events-list"
      [ngClass]="{
        'event-list-full': viewForm.get('view').value === 'list',
        collapsed: isSidebarCollapsed && viewForm.get('view').value === 'map',
      }"
    >
      <div *ngIf="!filteredEvents.length" class="no-events-message">
        <p i18n="@@noEventsFound">No events found</p>
      </div>

      <ng-container *ngIf="filteredEvents.length > 0 && showEventsOutsideView">
        <ng-container *ngFor="let heroReport of filteredEvents">
          <app-hero-report-card
            [heroReport]="heroReport"
            [account]="account"
            [canViewEod]="canViewEod"
            (cardClicked)="onHeroCardClicked($event)">
          </app-hero-report-card>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="filteredEvents.length > 0 && !showEventsOutsideView">
        <ng-container *ngFor="let heroReport of filteredEventsInView">
          <app-hero-report-card
            [heroReport]="heroReport"
            [account]="account"
            [canViewEod]="canViewEod"
            (cardClicked)="onHeroCardClicked($event)">
          </app-hero-report-card>
        </ng-container>
      </ng-container>
    </div>

    <div
      class="map-container"
      [ngClass]="{ hidden: viewForm.get('view').value !== 'map' }"
    >
      @if (viewForm.get("view").value === "map") {
        <button
          class="toggle-sidebar-button"
          [ngClass]="{ 'collapse-state': isSidebarCollapsed }"
          (click)="toggleSidebar()"
        >
          <i
            [ngClass]="
              isSidebarCollapsed
                ? 'ri-arrow-right-s-line'
                : 'ri-arrow-left-s-line'
            "
          ></i>
        </button>
      }
      <div class="top-controls">
        <app-user-menu></app-user-menu>
      </div>

      <app-mapbox
        [events]="filteredEvents"
        [mapLayers]="mapLayers"
        [latitude]="latitude ?? 0"
        [longitude]="longitude ?? 0"
        [mapType]="selectedMapType"
        [showEvacuationRadius]="showEvacuationRadius"
        [isLoading]="isLoading || isMapLoading"
        (markerClicked)="onMarkerClicked($event)"
        (createHeroReport)="onCreateHeroReportFromCoordinates($event)"
        (createSreReport)="onCreateSreReportFromCoordinates($event)"
        [createMapLayer]="addMapLayer.bind(this)"
        [updateMapLayer]="updateMapLayer.bind(this)"
        (layerSelected)="onLayerSelected($event)">
      </app-mapbox>

      <div class="right-controls">
        <button
          pButton
          type="button"
          class="custom-button"
          (click)="onLayersClick()"
          i18n-title="@@layersButton"
          title="Layers">
          <i class="ri-stack-fill"></i>
        </button>
      </div>

      <app-map-layer-dialog
        class="layer-dialog"
        *ngIf="selectedLayer"
        [selectedLayer]="selectedLayer"
        (save)="updateMapLayer($event)"
        (close)="onCloseLayerDialog()"
        (change)="onLayerPreviewChange($event)"
        [error]="mapLayerSaveError">
      </app-map-layer-dialog>

      <div class="bottom-controls">
        <button
          pButton
          type="button"
          class="custom-button"
          (click)="onAddEvent()"
          i18n-title="@@addEvent"
          title="Add Event">
          <i class="ri-file-add-fill"></i>
        </button>

        <button
          *ngIf="canEditMapLayer"
          pButton
          type="button"
          class="custom-button"
          (click)="onMapLayerAdd()"
          i18n-title="@@addMapLayer"
          title="Add Map Layer">
          <i class="ri-shape-fill"></i>
        </button>

        <button
          *ngIf="selectedLayer"
          pButton
          type="button"
          class="custom-button"
          (click)="onMapLayerDelete()"
          i18n-title="@@deleteMapLayer"
          title="Delete Map Layer">
          <i class="ri-delete-bin-fill"></i>
        </button>

        <div class="zoom-buttons">
          <button
            pButton
            type="button"
            class="zoom-button zoom-in"
            (click)="onZoomInClick()"
            i18n-title="@@zoomIn"
            title="Zoom in">
            <i class="ri-add-fill"></i>
          </button>
          <button
            pButton
            type="button"
            class="zoom-button zoom-out"
            (click)="onZoomOutClick()"
            i18n-title="@@zoomOut"
            title="Zoom out">
            <i class="ri-subtract-fill"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

@if (showLayersModal) {
  <app-map-layers-modal
    [visible]="showLayersModal"
    [latitude]="latitude!"
    [longitude]="longitude!"
    [selectedMapType]="selectedMapType"
    [showEvacuationRadius]="showEvacuationRadius"
    [showSwimLanes]="showSwimLanes"
    [showPendingEvents]="showPendingEvents"
    [showCompletedEvents]="showCompletedEvents"
    [showEventsOutsideView]="showEventsOutsideView"
    (visibleChange)="showLayersModal = $event"
    (apply)="onApplyLayers($event)">
  </app-map-layers-modal>
}

<app-hero-report-modal
  (save)="onHeroReportSave($event)">
</app-hero-report-modal>

<div class="overlay" *ngIf="showPanel" (click)="closePanel()">
  <div class="center-panel" (click)="$event.stopPropagation()">

    <button class="close-button" (click)="closePanel()" i18n-title="@@closePanel" title="Close">
      <i class="ri-close-fill"></i>
    </button>
    <app-hero-report-card
      *ngIf="selectedHero"
      [heroReport]="selectedHero"
      [account]="account"
      [canViewEod]="canViewEod">
    </app-hero-report-card>

  </div>
</div>